define('PDPAssemblyItem',
  [
    'PDPAssemblyItem.View',
    'js.cookie',
    'jQuery',
    'Utils',
    'underscore'
  ], function (
    PDPAssemblyItemView,
    Cookies,
    jQuery,
    Utils,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var userProfile = container.getComponent('UserProfile');
        var viewNames = [];

        if (layout && userProfile) {
          var AGILINE_URL = 'https://aiworksdev.agiline.com/global/index?globalurlid=20ADF285-3063-4654-867C-67A3B22DBABF';

          userProfile.getUserProfile().then(function (profile) {
            var pdp = container.getComponent('PDP');
            if (profile && pdp) {
              viewNames = [
                pdp.PDP_FULL_VIEW,
                pdp.PDP_QUICK_VIEW
              ];

              layout.addChildView('Iframe.Bottom', function () {
                return new PDPAssemblyItemView({ pdp: pdp, profile: profile, position: 'bottom' });
              });

              layout.addChildView('Iframe.Side', function () {
                return new PDPAssemblyItemView({ pdp: pdp, profile: profile, position: 'side' });
              });

              window.LoadGloablURLSide = function () {
                jQuery('html, body').animate({
                  scrollTop: 0
                }, 'slow');
                jQuery('#ifrmCart').attr('src', AGILINE_URL + '&param2=' + sessionId +
								'&param1=' + pdp.getItemInfo().item.externalid +
								'&parent_url=' + window.location.href);

                jQuery('#ifrmCart').css('display', 'block');
                if (Utils.isPhoneDevice()) {
                  jQuery('#ifrmCart').css('display', 'none');
                  jQuery('.header-menu-quote').css('display', 'none');
                  jQuery('#ifrmCart').removeClass('mobile-ifrmCart');
                  jQuery('#ifrmCart').attr('style', 'width: 405px !important; display: block; height: 876px; position:absolute; top: 0; right: 0; z-index: 999999999999');
                }
              };

              _.each(viewNames, function eachViewNameBottomFrame(viewName) {
                pdp.addToViewContextDefinition(viewName, 'bottomFrame', 'boolean', function () {
                  var iteminfo = pdp.getItemInfo();
                  return iteminfo && iteminfo.item.custitem_uc_bottom_iframe;
                });
              });

              // Mobile Changes
              layout.addToViewContextDefinition('RequestQuoteAccessPoints.HeaderLink.View', 'isMobile', 'boolean', function () {
                return Utils.isPhoneDevice() || Utils.isTabletDevice();
              });
            }
          });
          var sessionId = Cookies.get('NLVisitorId');

          jQuery.ajax({
            url: 'https://aiworksdev.agiline.com//global/index?globalurlid=B6C20512-57EB-43F8-88CC-8457672799C1&session=' + sessionId,
            type: 'get',
            async: false,
            success: function (data) {
              var parsedData = data.result && JSON.parse(data.result);
              layout.addToViewContextDefinition('RequestQuoteAccessPoints.HeaderLink.View', 'titleTrigger', 'string', function (context) {
                return parsedData && parsedData[0].Count > 0 ? 'Send your Quote' : context.title;
              });
              layout.addToViewContextDefinition('RequestQuoteAccessPoints.HeaderLink.View', 'requestCount', 'string', function () {
                return parsedData && parsedData[0].Count || 0;
              });
            },
            error: function (e) {
              console.log(e);
              layout.addToViewContextDefinition('RequestQuoteAccessPoints.HeaderLink.View', 'titleTrigger', 'string', function (context) {
                return context.title;
              });
              layout.addToViewContextDefinition('RequestQuoteAccessPoints.HeaderLink.View', 'requestCount', 'string', function () {
                return '-';
              });
            }
          });

          // global function for loading
          window.LoadGloablURL = function () {
            jQuery('#ifrmCart').attr('src', AGILINE_URL + '&param2=' + sessionId +
						'&parent_url=' + window.location.href);

            jQuery('#ifrmCart').css('display', 'block');

            if (Utils.isPhoneDevice()) {
              jQuery('#ifrmCart').css('display', 'none');
              jQuery('#ifrmCart').removeClass('mobile-ifrmCart');
              jQuery('.header-menu-quote').css('display', 'none');
              jQuery('#main').removeClass('header-sidebar-opened');
              jQuery('#ifrmCart').attr('style', 'width: 405px !important; display: block; height: 876px; position:absolute; top: 0; right: 0; z-index: 999999999999');
            }
          };
        }

      }
    };
  });
